import { render, staticRenderFns } from "./RecommendLogin.vue?vue&type=template&id=5d1027d0&scoped=true"
import script from "./RecommendLogin.vue?vue&type=script&lang=js"
export * from "./RecommendLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1027d0",
  null
  
)

export default component.exports